module.exports = __webpack_public_path__ + "img/united.c38887bc.png";